export const LOCATION_GROUP_FILTER = "locationGroupFilter"
export const CATEGORY_GROUP_FILTER = "categoryGroupFilter"
export const PRODUCT_GROUP_FILTER = "productGroupFilter"
export const BRAND_GROUP_FILTER = "brandGroupFilter"
export const AGE_GROUP_FILTER = "ageGroupFilter"
export const GENDER_GROUP_FILTER = "genderGroupFilter"
export const SEGMENTATION_GROUP_FILTER = "segmentationGroupFilter"
export const CHANNEL_GROUP_FILTER = "channelGroupFilter"
export const PSYCHOGRAPHICS_GROUP_FILTER = "psychographicGroupFilter"
export const FORMAT_GROUP_FILTER = "formatGroupFilter"

export const COMMA_SEPARATOR = ", "

export const REGIONS = "regions"
export const COUNTIES = "counties"
export const STORES = "stores"
export const FORMATS = "formats"
export const DEPARTMENTS = "departments"
export const CATEGORIES = "categories"
export const SUBCATEGORIES = "subcategories"
export const VENDORS = "vendors"
export const BRANDS = "brands"
export const FINELINES = "finelines"
export const FINELINE = "fineline"
export const PRODUCTS = "products"
export const PRODUCT_NUMBERS = "product_numbers"
export const AGE = "age"
export const SEGMENTATION = "segmentation"
export const GENDER = "gender"
export const CHANNEL = "channel"
export const PSYCHOGRAPHICS = "psychographics"
export const CUSTOMER_TYPE = "customer_type"
export const STORE = "store"

export const REGIONS_FILTER_ENDPOINT = "/filters/region"
export const COUNTIES_FILTER_ENDPOINT = "/filters/county"
export const STORES_FILTER_ENDPOINT = "/filters/store"
export const FORMATS_FILTER_ENDPOINT = "/filters/format"
export const GEOGRAPHIC_STORES_ENDPOINT = "/transactional/geographic/stores"
export const DEPARTMENTS_FILTER_ENDPOINT = "/filters/departments"
export const CATEGORIES_FILTER_ENDPOINT = "/filters/categories"
export const SUBCATEGORIES_FILTER_ENDPOINT = "/filters/subcategories"
export const VENDORS_FILTER_ENDPOINT = "/filters/vendors"
export const BRANDS_FILTER_ENDPOINT = "/filters/brands"
export const PRODUCT_FILTER_ENDPOINT = "/filters/product"
export const FINELINES_FILTER_ENDPOINT = "/filters/fineline"

export const DEPARTMENT_RELATIONSHIP = "/filters/relations/department"
export const RELATIONSHIP_DEPARTMENT = "department_relationship"
export const FINELINE_RELATIONSHIP = "/filters/relations/fineline"

export const ALL_STORES_FILTER = "all_stores_filter"
export const REGION_FILTER = "region_filter"
export const COUNTY_FILTER = "county_filter"
export const FORMATS_FILTER = "formats_filter"
export const STORES_FILTER = "stores_filter"
export const DEPARTMENT_FILTER = "department_filter"
export const CATEGORY_FILTER = "category_filter"
export const SUBCATEGORY_FILTER = "subcategory_filter"
export const VENDORS_FILTER = "vendors_filter"
export const BRANDS_FILTER = "brands_filter"
export const PRODUCTS_FILTER = "products_filter"
export const FINELINES_FILTER = "finelines_filter"
export const FINELINE_FILTER = "fineline_filter"

export const GENDER_FEMALE = "female"
export const GENDER_MALE = "male"

export const globalFiltersMapBackendConfig = {
	regions: "region",
	counties: "county",
	stores: "store",
	vendors: "vendors",
	formats: "formats",
	brands: "brands",
	products: "products",
	departments: "departments",
	subcategories: "subcategories",
	fineline: "fineline",
	categories: "categories",
	channel: "channel",
	age: "age",
	gender: "gender",
	psychographics: "psychographics",
	customer_type: "customer_type",
}
